import React from "react";

const LazySelect = React.lazy(async () => {
	// biome-ignore lint/style/noRestrictedImports: component usage
	const { Select } = await import("@radix-ui/react-select");

	return { default: Select };
});

export type SelectProps = React.ComponentProps<typeof LazySelect>;

export const Select: React.FC<SelectProps> = (props) => (
	<React.Suspense fallback={props.children}>
		<LazySelect {...props} />
	</React.Suspense>
);
